import { useConfig } from '@browsing/config';
import { useVariant } from '@client/lib/assignments';
import { getCookie } from '@client/helpers/cookie';
import { isClient } from '@pegasus/utils';

export const usePlusNewCampaignCard =
    isClient() && getCookie('zl_plus_new_campaign_card') === 'true'
        ? () => true
        : () => {
              const isConfigEnabled = useConfig().isEnabled('plus_new_campaign_card');

              /**
               * We'll take out this part once the A/B test is done.
               * Variants:
               * ea_twice_a_week_showstopper (control)
               * daily_ea_campaign_card
               */
              const isVariantEnabled = useVariant(
                  'a2d9be33-f26c-4d47-a071-4ad1807b9a91',
                  'daily_ea_campaign_card',
              );

              return isConfigEnabled || isVariantEnabled || false;
          };
